export const BOOKING_URL = "https://app.acuityscheduling.com/schedule.php?owner=37994983&appointmentType=93094933";

export const getBookingUrl = () => {
  if (typeof window === "undefined") return BOOKING_URL;
  const gclid = new URLSearchParams(window.location.search).get("gclid");
  if (!gclid) return BOOKING_URL;
  const sep = BOOKING_URL.includes("?") ? "&" : "?";
  return `${BOOKING_URL}${sep}gclid=${encodeURIComponent(gclid)}`;
};

export const trackEvent = (action, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", action, params);
  }
};

export const HERO_IMAGE = "/images/hero-handshake.webp";

export const MODALITIES = [
  {
    name: "Cold Plunge",
    tag: "Deliberate cold exposure for inflammation, mood and mental edge.",
    img: "/images/cold-plunge.jpg",
    span: "lg:col-span-5 lg:row-span-2"
  },
  {
    name: "Infrared Sauna",
    tag: "Deep heat for circulation, detoxification and calm.",
    img: "/images/sauna.jpg",
    span: "lg:col-span-7"
  },
  {
    name: "Salt Float",
    tag: "Weightless sensory reset in magnesium-rich stillness.",
    img: "/images/float.jpg",
    span: "lg:col-span-4"
  },
  {
    name: "Compression",
    tag: "Dynamic air compression to flush legs and speed recovery.",
    img: "/images/compression.jpg",
    span: "lg:col-span-3"
  },
  {
    name: "Red Light",
    tag: "Photobiomodulation for skin, cellular repair and energy.",
    img: "/images/red-light.jpg",
    span: "lg:col-span-4"
  },
  {
    name: "Halo Therapy",
    tag: "Dry salt therapy for lungs, breathing and skin.",
    img: "/images/halo.jpg",
    span: "lg:col-span-4"
  },
  {
    name: "PEMF",
    tag: "Pulsed electromagnetic fields to recharge at the cellular level.",
    img: "/images/pemf.jpg",
    span: "lg:col-span-4"
  },
  {
    name: "Hyperbaric Oxygen",
    tag: "Pressurised oxygen (HBOT) to accelerate healing from within.",
    img: "/images/hbot.jpg",
    span: "lg:col-span-8"
  }
];

export const CAPSULE_IMAGE = "/images/capsule.jpg";

export const FACILITY_IMAGE = "/images/lobby.jpg";
